import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { isStatusTag, useTagClassName } from './utils';
import { tagDefaultTheme } from './theme';
import { TAG_CLASS_PREFIX, TAG_DELETE_BEHAVIOUR_OPTIONS } from './constants';
import { TagCloseIcon, TagCloseIconContainer, TagRoot, TagTypography } from './style';
import { useTag } from './utils/useTag';
export var Tag = forwardRef(function Tag(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(TAG_CLASS_PREFIX, tagDefaultTheme);

  var _useTag = useTag(restProps, ref),
      rootProps = _useTag.rootProps,
      tagTypographyProps = _useTag.tagTypographyProps,
      tagCloseIconContainerProps = _useTag.tagCloseIconContainerProps,
      content = _useTag.content,
      deleteOption = _useTag.deleteOption,
      type = _useTag.type,
      disabled = _useTag.disabled,
      small = _useTag.small;

  var classOverride = useTagClassName(TAG_CLASS_PREFIX, className, deleteOption, type, small);
  return React.createElement(TagRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), React.createElement(TagTypography, Object.assign({}, tagTypographyProps, {
    className: classOverride.Label,
    theme: theme,
    paragraph: true,
    small: true
  }), content), !isStatusTag(type) && (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED || deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER && !disabled) ? React.createElement(TagCloseIconContainer, Object.assign({}, tagCloseIconContainerProps, {
    className: classOverride.CloseIconContainer,
    theme: theme
  }), React.createElement(TagCloseIcon, {
    className: classOverride.CloseIcon,
    theme: theme
  })) : null);
});
Tag.defaultProps = {
  deleteOption: TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER,
  type: 'default'
};